define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll', 'lightbox', 'slider-carousel-infinite-enhanced', 'jump'],
    function ($, transit, modernizr, container, preloader, router, scroll, lightboxFactory, sliderCarouselInfiniteEnhancedFactory, jumpFactory) {

        var module = (function () {

            var name = 'module-game';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            const lightbox = lightboxFactory.create();
            const sliderMobile = sliderCarouselInfiniteEnhancedFactory.create();
            const jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {
                actionSupriseCookie: function () {
                    $.ajax({
                        url: model.publicVars.ajaxSupriseCookieAction,
                        type: 'GET',
                        data: {}
                    }).done(function (data) {

                    });
                }
            }

            /* view */

            view.publicVars = {
                gameCurrent: {
                    id: null,
                    width: null,
                    height: null,
                    featured: false
                }
            };

            view.privateVars = {
                gameCurrent: {
                    id: null,
                    width: null,
                    height: null,
                    featured: false
                },

                gameSize: {
                    width: 900,
                    height: 537
                },
            };

            view.startup = function () {

                view.privateVars.gameCurrent = view.publicVars.gameCurrent;

                $(view.publicVars.cssId.moduleGameFrameIframeId).each(function () {
                    this.src = this.src;
                });

                $(view.publicVars.cssId.moduleGameLightboxCallCls).removeAttr('href');
                $(view.publicVars.cssId.moduleGameLightboxCallInactiveCls).removeAttr('href');

                if(view.privateVars.gameCurrent.id) {

                    let currentHandler = null;

                    if(view.privateVars.gameCurrent.featured == 'true') {
                        currentHandler = view.publicVars.cssId.moduleGameFeaturedFrameBigGameWrapperCls;
                    } else {
                        currentHandler = view.publicVars.cssId.moduleGameSliderItemCls + view.privateVars.gameCurrent.id;
                    }

                    view.methods.showLightbox(currentHandler);
                }

                lightbox.setCloseCallback(function () {
                    $(view.publicVars.cssId.moduleGameFrameIframeId).attr('src', '');
                    $(view.publicVars.cssId.moduleGameFrameIframeId).removeAttr('src');

                    const metaTitle = container.getData($(view.publicVars.cssId.moduleGameId)[0], 'meta.title');

                    router.enable();

                    router.route(view.publicVars.baseUrl + view.publicVars.slug, metaTitle);

                    view.privateVars.gameCurrent = {
                        id: null,
                        width: null,
                        height: null
                    };
                });

                preloader.setPreloadBulk(name, view.publicVars.preloadImgTab);
            };

            view.bind = function () {
                $(view.publicVars.cssId.moduleGameId).on('click', view.publicVars.cssId.moduleGameLightboxCallCls, function () {
                    view.methods.showLightbox(this);

                    return false;
                });

                $(window).resize(() => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.gameCurrent.width, view.privateVars.gameCurrent.height);
                    }
                });

                $(window).on('orientationchange', () => {
                    if (lightbox.getStatus() === 1) {
                        view.methods.calculateLightboxSize(view.privateVars.gameCurrent.width, view.privateVars.gameCurrent.height);
                    }
                });

                $(view.publicVars.cssId.moduleGameEggSupriseId).click(function () {
                    view.methods.handleEggHuntClick();
                });
            };

            view.methods = {
                handleEggHuntClick: () => {

                    model.methods.actionSupriseCookie();

                    jump.centerTo(view.publicVars.cssId.moduleGameFeaturedFrameBigGameWrapperCls, {});

                    $(view.publicVars.cssId.moduleGameEggSupriseId).removeClass(view.publicVars.cssId.animateAnimatedCls.substr(1));
                    $(view.publicVars.cssId.moduleGameEggSupriseId).removeClass(view.publicVars.cssId.animateRotateInCls.substr(1));
                    $(view.publicVars.cssId.moduleGameEggSupriseId).transit({ scale: 0, rotate: '360deg' }, 300);

                    $(view.publicVars.cssId.moduleGameEggHuntPosterSrcCls).css({ display: 'block', opacity: 0, scale: 0.5 });
                    $(view.publicVars.cssId.moduleGameEggHuntPosterLockSrcCls).transit({ opacity: 0});
                    $(view.publicVars.cssId.moduleGameFeaturedFrameBigGameWrapperCls).removeClass(view.publicVars.cssId.moduleGameLightboxCallInactiveCls.substr(1));
                    $(view.publicVars.cssId.moduleGameFeaturedFrameBigGameWrapperCls).addClass(view.publicVars.cssId.moduleGameLightboxCallCls.substr(1));
                    $(view.publicVars.cssId.moduleGameEggHuntPosterSrcCls).transit({ opacity: 1, scale: 1 }, 300, function () {

                    });
                },

                showLightbox: (handler) => {
                    const gameSrc = container.getData($(handler)[0], 'game.src');
                    const width = container.getData($(handler)[0], 'width');
                    const height = container.getData($(handler)[0], 'height');
                    const id = container.getData($(handler)[0], 'id');
                    const metaTitle = container.getData($(handler)[0], 'meta.title');
                    const slug = container.getData($(handler)[0], 'slug');

                    const lightboxSize = view.methods.calculateLightboxSize(width, height);

                    view.privateVars.gameCurrent = {
                        id: id,
                        width: width,
                        height: height
                    };

                    $(view.publicVars.cssId.moduleGameFrameIframeId).removeAttr('src');
                    $(view.publicVars.cssId.moduleGameFrameIframeId).css({ opacity: 0, scale: 0.5});
                    $(view.publicVars.cssId.moduleGameLightboxLoaderWrapperId).css({ display: 'block', opacity: 0, scale: 0, rotate: '0deg'})

                    lightbox.showLayer(function () {
                        $(view.publicVars.cssId.moduleGameLightboxLoaderWrapperId).transit({ opacity: 1, scale: 1, rotate: '360deg'}, 300, function () {

                            router.route(view.publicVars.baseUrl + view.publicVars.slug
                                + '/' + slug, metaTitle);

                            router.disable();

                            setTimeout(function () {
                                $(view.publicVars.cssId.moduleGameFrameIframeId).attr('src', gameSrc);
                                $(view.publicVars.cssId.moduleGameFrameIframeId).transit({ opacity: 1, scale: 1}, 300);
                            }, 500);

                        })
                    });
                },

                calculateLightboxSize: (width, height) => {

                    const windowWidth = $(window).width();
                    const windowHeight = $(window).height();

                    const paddingTop = parseInt($(view.publicVars.cssId.moduleGameLightboxAreaId).css('padding-top'));
                    const paddingBottom = parseInt($(view.publicVars.cssId.moduleGameLightboxAreaId).css('padding-bottom'));
                    const paddingLeft = parseInt($(view.publicVars.cssId.moduleGameLightboxAreaId).css('padding-left'));
                    const paddingRight = parseInt($(view.publicVars.cssId.moduleGameLightboxAreaId).css('padding-right'));

                    const paddingTopInner = parseInt($(view.publicVars.cssId.moduleGameLightboxInnerId).css('padding-top'));
                    const paddingBottomInner = parseInt($(view.publicVars.cssId.moduleGameLightboxInnerId).css('padding-bottom'));
                    const paddingLeftInner = parseInt($(view.publicVars.cssId.moduleGameLightboxInnerId).css('padding-left'));
                    const paddingRightInner = parseInt($(view.publicVars.cssId.moduleGameLightboxInnerId).css('padding-right'));

                    const topModifier = (- parseInt($(view.publicVars.cssId.moduleGameLightboxCloseId).css('top'))) * 2;
                    const rightModifier = (- parseInt($(view.publicVars.cssId.moduleGameLightboxCloseId).css('right'))) * 2;

                    const maxWidth = windowWidth - paddingLeft - paddingRight - paddingLeftInner - paddingRightInner - rightModifier;
                    const maxHeight = windowHeight - paddingTop - paddingBottom - paddingTopInner - paddingBottomInner - topModifier;

                    // const maxWidth = windowWidth;
                    // const maxHeight = windowHeight;

                    let lightboxSize;

                    let adjustedWidth = view.privateVars.gameSize.width;
                    let adjustedHeight = view.privateVars.gameSize.height;

                    if (width !== '' && height !== '' && parseInt(width) >= 400 && parseInt(height) >= 400) {
                        adjustedWidth = parseInt(width);
                        adjustedHeight = parseInt(height);
                    }

                    //adjustedWidth = adjustedWidth + paddingLeft + paddingRight;
                    //adjustedHeight = adjustedHeight + paddingTop + paddingBottom;

                    lightboxSize = view.methods.calculateSizeProportionForMaxValues(maxWidth, maxHeight,
                        adjustedWidth, adjustedHeight);

                    const newWidth = lightboxSize.width + paddingLeft + paddingRight + paddingLeftInner + paddingRightInner;
                    const newHeight = lightboxSize.height + paddingTop + paddingBottom + paddingTopInner + paddingBottomInner;

                    $(view.publicVars.cssId.moduleGameLightboxAreaId)
                        .css({width: newWidth + 'px', height: newHeight + 'px'});

                },

                calculateSizeProportionForMaxValues: (maxWidth, maxHeight, width, height) => {

                    if (width <= maxWidth && height <= maxHeight) {
                        return {width: width, height: height};
                    }

                    const widthHeightRatio = width / height;
                    const heightWidthRatio = height / width;

                    if (width > maxWidth) {

                        const widthDiff = width - maxWidth;
                        width = maxWidth;
                        height = height - (heightWidthRatio * widthDiff);
                    }

                    if (height > maxHeight) {
                        const heightDiff = height - maxHeight;
                        height = maxHeight;

                        width = width - (widthHeightRatio * heightDiff);
                    }

                    return {width: width, height: height};
                }
            };

            /* custom events */
            // pubSub.subscribe('view/actionShowSaveThxMsg', view.methods.form.actionShowSaveThxMsg);
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    lightbox.init(options.lightboxSetup);
                    view.init(options);
                    scroll.init();
                    sliderMobile.init(options.sliderMobileSetup);
                }
            };


        })();

        return module;


    });
